export function create_employee_form() {
  const employees_form = {
    name: '',
    role: '',
    department: 'Finance',
    manager: '',
    joined: '',
    status: 'Compliant'
  };
  return employees_form
}

function employee_filter_department(filter_id) {
  const filter_map = {
    finance: 'Finance',
    operations: 'Operations',
    it: 'IT',
    marketing: 'Marketing'
  };
  const department = Reflect.get(filter_map, filter_id);
  return department;
}

export const employee_register_computed = {
  visible_employee_filters() {
    return this.employee_filters.map((filter) => ({
      ...filter,
      active: this.active_employee_filter === filter.id
    }));
  },
  filtered_employee_rows() {
    if (this.active_employee_filter === 'all') return this.employee_rows;
    const department = employee_filter_department(this.active_employee_filter);
    return this.employee_rows.filter((row) => row.dept === department);
  }
};

export const employee_register_methods = {
  set_tab(tab_id) {
    this.active_tab = tab_id;
  },
  set_employee_filter(filter_id) {
    this.active_employee_filter = filter_id;
  },
  open_employee_modal() {
    this.employee_form = create_employee_form();
    this.show_employee_modal = true;
  },
  close_employee_modal() {
    this.show_employee_modal = false;
  },
  create_employee() {
    this.show_employee_modal = false;
  },
  open_employee_drawer(ref) {
    const active_employee_drawer = Reflect.get(this.employee_drawers || {}, ref) || null;
    this.active_employee_drawer = active_employee_drawer;
  },
  close_employee_drawer() {
    this.active_employee_drawer = null;
  }
};
